












import Vue from 'vue';
import { ResponseData } from '@/types';
import CampaignForm from '@/components/campaign/CampaignForm.vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'CreateCampaign',
  components: {
    CampaignForm,
  },

  async mounted() {
    this.loadData = true;
    await Promise.all([
      this.$store.commit(
        'changeTitle',
        this.$tc('pages.campaignForm.subTitle', 0)
      ),
      this.$store.dispatch('countries'),
      this.$store.dispatch('ssps', {
        expand: 'creative_formats,img,geo',
      }),
      this.$store.dispatch('langs'),
      this.$store.dispatch('categories'),
      this.$store.dispatch('offers'),
      this.$store.dispatch('os'),
      this.$store.dispatch('deviceTypes'),
    ]);
    this.loadData = false;
  },

  computed: {
    ...mapGetters({
      group: 'campaignGroups/getGroup',
    }),
    title(): string {
      return this.group?.name || '';
    },
  },

  methods: {
    ...mapActions({
      invalidFormNotificationAction: 'invalidFormNotification',
    }),
    async create(formData) {
      this.isSavingForm = true;
      const response: ResponseData = await this.$store.dispatch(
        'createCampaign',
        formData
      );
      if (response.success) {
        this.isSavingForm = false;
        window.location.href = this.backUrl;
      } else {
        if (response.data?.length) {
          this.errors = response.data;
        }

        this.isSavingForm = false;
        this.invalidFormNotificationAction();
      }
    },
    setBackUrl(url) {
      if (url) {
        this.backUrl = url;
      }
    },
  },

  data: function () {
    return {
      errors: [],
      backUrl: '/campaigns',
      isSavingForm: false,
      loadData: false,
    };
  },
});
